/* StudioSteen Log - v1.0.2  Usage: log('message'/{}); */
function log() {
  'use strict';
  var messages = '';
  var objects = [];

  if (window.console) {
    for (var i = 0; i < arguments.length; i++) {
      var message = arguments[i];

      if (typeof message !== 'undefined') {
        if (typeof message === 'string' || typeof message === 'number') {
          messages += ' ' + message;
        } else {
          objects.push(message);
        }
      }
    }

    if (messages !== '') {
      var date = new Date();
      window.console.log(date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + '.' + date.getMilliseconds() + ': ' + messages);
    }
    if (objects.length > 0) {
      for (var j = 0; j < objects.length; j++) {
        window.console.log(objects[j]);
      }
    }
  }
}
